
import { removeUnderScrSpCharSpaceBet, sliceText } from "../../../utils/common";

import {
    Box,
    Button,
    Col,
    Flex,
    Gap,
    InputField,
    Row,
    SelectField,
    Switchbox,
    Typography,
} from "../../../ppui";
import { Snackbar } from "../../../ppui/snackbar";
import { logger, safeString } from "../../../utils/logger";
import useCommonfn from "../../../utils/useCommonfn";
import StatutoryGratuityActView from "./gratuity-act-view";
import { getTodayDate } from "./graturity-utils";
import useGraturityService from "./use-graturity-service";

const StatutoryGratuity = () => {
    const {navigateToDashBoard}=useCommonfn()
    const { loading,
        gratuityInfoData,
        gratuityInfo,
        handleChange,
        errors,
        isGratuityEnabled,
        selectValue,
        handleSubmit,
        statutoryGratuityCreateUpdateloading,
        setOpenPtaxModal,
        handleCloseStatutoryPtaxModal,
        handleOpenStatutoryPtaxModal,
        snackbarVisible,
        closeSnackbar,
        snackbarMessage,
        snackColor,
        setstatutoryGratuityCreateUpdateloadingLoading,
        handleToggleGratuity } = useGraturityService()
    if (loading) {
        return <p>Loading Statutory Gratuity ....</p>
    }
    // pTaxViewData.status && pTaxViewData?.slabData?.tax_cal?.length
    logger.log(gratuityInfoData,"gratuityInfoData")
    return (
        <>
            {gratuityInfoData?.status===false ||gratuityInfoData?.status===undefined  ? (
                <>
                    <Flex justifyContent="space-between" mb={20}>
                        <Box>
                            <Typography variant="h5" mb={"0"}>
                                Gratuity ACT
                            </Typography>
                            <Typography variant="body2" mb={"0"}>
                                {`Deduction Circle: Monthly`}
                            </Typography>
                        </Box>
                        <Switchbox
                            label={isGratuityEnabled ? 'Disable Gratuity ACT' : 'Enable Gratuity ACT'}
                            color="Primary"
                            size="lg"
                            lableFirst
                            checked={isGratuityEnabled}
                            onChange={handleToggleGratuity}
                        />
                     
                      
                    </Flex>
                    <Row rowGap>
                        <Col sm={12} md={6} lg={4} xxl={3}>
                            <InputField
                                fullWidth
                                name="gratuity_act_no"
                                label="Gratuity Act No"
                                placeholder="Type Here..."
                                type="tel"
                                required={true}
                                value={gratuityInfo.gratuity_act_no}
                                valueSinc={!!gratuityInfo.gratuity_act_no}
                                // valueSinc
                                onChange={(e) => handleChange(e.target.value, "gratuity_act_no", {
                                    formateFn: (val) => {
                                        return sliceText(removeUnderScrSpCharSpaceBet(safeString(val)), 150)
                                    }
                                })}
                                error={errors.gratuity_act_no}
                                helperText={errors.gratuity_act_no}
                                disabled={isGratuityEnabled ? false : true}
                            />
                        </Col>
                        <Col sm={12} md={6} lg={4} xxl={3}>
                            <SelectField
                                fullWidth
                                label="Gratuity Type"
                                name="gratuity_type"
                                // options={[
                                //     { id: "Gratuity", name: "Gratuity Run By Under Labour ACT." },
                                //     { id: "10%", name: "Gratuity Run By Any Insurance Company" },
                                // ]}
                                options={[
                                    { id: 1, name: "Gratuity Run By Under Labour ACT." },
                                    { id: 2, name: "Gratuity Run By Any Insurance Company" },
                                ]}
                                placeholder="Select Here..."
                                required={true}
                                value={
                                    selectValue
                                }
                                defaultValue={gratuityInfo.gratuity_type}
                                onChange={(val) => handleChange(val, 'gratuity_type')}
                                error={errors.gratuity_type}
                                helperText={errors.gratuity_type}
                                disabled={!isGratuityEnabled}
                            />

                        </Col>

                        <Col sm={12} md={6} lg={4} xxl={3}>
                            <InputField
                                type="date"
                                fullWidth
                                name="coverage_date"
                                label="Gratuity ACT Coverage Date"
                                placeholder="Type Here..."
                                valueSinc
                                required={true}
                                value={gratuityInfo.coverage_date}
                                onChange={(e) => handleChange(e.target.value, "coverage_date")}
                                error={errors.coverage_date}
                                helperText={errors.coverage_date}
                                max={getTodayDate()}
                                disabled={isGratuityEnabled ? false : true}
                                readonly={true}
                                onKeyDown={(e) => { e.preventDefault() }}
                            />
                        </Col>
                    </Row>
                    <Gap height={50} />
                    <Flex justifyContent="flex-end" gap={"10"}>
                        <Button onClick={navigateToDashBoard} variant="outlined" disabled={isGratuityEnabled ? false : true}>
                            Cancel
                        </Button>
                        <Button color="primary" onClick={() => handleSubmit()} variant="contained" loading={statutoryGratuityCreateUpdateloading} disabled={isGratuityEnabled ? false : true}>
                            Save
                        </Button >
                    </Flex>
                </>
            ) : (
               <>
                <StatutoryGratuityActView
                    handleOpenStatutoryPtaxModal={handleOpenStatutoryPtaxModal}
                    handleCloseStatutoryPtaxModal={handleCloseStatutoryPtaxModal}
                    setOpenPtaxModal={setOpenPtaxModal}
                    statutoryGratuityCreateUpdateloading={statutoryGratuityCreateUpdateloading}
                    setstatutoryGratuityCreateUpdateloadingLoading={setstatutoryGratuityCreateUpdateloadingLoading}
                    gratuityInfo={gratuityInfo}
                    handleSubmit={handleSubmit}
                    errors={errors}
                    handleChange={handleChange}
                    selectValue={selectValue}
                    isGratuityEnabled={isGratuityEnabled}
                    gratuityInfoData={gratuityInfoData}
                    handleToggleGratuity={handleToggleGratuity}
                />
               </>
            )}

            <Snackbar
                message={snackbarMessage}
                color={snackColor}
                variant="contained"
                size="medium"
                position="top-right"
                onClose={
                    closeSnackbar}
                onOpen={snackbarVisible}
                loading={false}
                duration={3000}
            />
        </>
    );
};

export default StatutoryGratuity;